import { FC, CSSProperties } from 'react';

export enum Sizes {
  xs = 'xs',
  sm = 'sm',
  base = 'base',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  '2xl' = '2xl',
  '3xl' = '3xl',
  '4xl' = '4xl',
  '5xl' = '5xl'
}

interface RadioButtonChoiceProps {
  text: string;
  selected: boolean;
  handleOnClick: () => void;
  size?: Sizes;
  radio?: boolean;
  last?: boolean;
  isSide?: boolean;
  buttonSize?: string;
  style?: CSSProperties;
}

const RadioButtonChoice: FC<RadioButtonChoiceProps> = ({
  text,
  handleOnClick,
  last = false,
  radio = false,
  selected,
  size = Sizes.base,
  buttonSize = "w-full",
  style
}) => {
  const baseClasses = "flex items-center cursor-pointer rounded-md transition-all duration-200";

  // Définition des classes de taille basées sur l'enum
  const getSizeClasses = (size: Sizes): string => {
    switch (size) {
      case Sizes.sm:
        return "px-3 py-1.5";
      case Sizes.md:
        return "px-4 py-2";
      case Sizes.lg:
        return "px-6 py-4";
      default:
        return "px-4 py-2"; // taille par défaut (base)
    }
  };

  const sizeClasses = getSizeClasses(size);
  const colorClasses = selected
    ? "bg-gray-50 text-primary border border-primary"
    : "bg-white text-gray-800 border border-gray-300 hover:border-primary";
  const combinedClasses = `${baseClasses} ${sizeClasses} ${colorClasses}`;

  return (
    <div
      className={`group ${combinedClasses}`}
      onClick={handleOnClick}
      style={style}
    >
      {radio && (
        <div>
          <label className="flex">
            <input
              key={Math.random() + 1}
              type="radio"
              name={`choice-${Math.random()}`}
              checked={selected}
              onChange={() => { }} // handleOnClick géré au niveau parent
              className="sr-only"
            />
            <span className={`
              w-4 h-4 rounded-full border flex items-center justify-center group-hover:border-primary
              ${selected
                ? 'border-primary bg-white'
                : 'border-gray-400 bg-white'
              }
            `}>
              {selected && (
                <span className="w-2 h-2 rounded-full bg-primary"></span>
              )}
            </span>
          </label>
        </div>
      )}
      <p className={`text-sm leading-5 pr-4 pl-6 ${selected ? 'font-bold' : 'font-normal'} ${buttonSize}`}>{text}</p>
    </div>
  );
};

export default RadioButtonChoice;
